import { useTranslation } from "react-i18next";
import { Button } from "./Button";

export function LoadError({ onRetry, retrying = false }: {
  onRetry: () => void;
  retrying?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div role="alert" className="space-y-4 rounded-xl border border-cream-border bg-cream-light p-6 text-center text-navy">
      <p>{t("common.load_error")}</p>
      <Button type="button" onClick={onRetry} disabled={retrying}>
        {t(retrying ? "common.loading" : "common.retry")}
      </Button>
    </div>
  );
}
